export const TEXT_SESSION_TIMEOUT_HEADER = "Let us know you're still there";
export const TEXT_SESSION_TIMEOUT_BODY = "To keep your money safe, we automatically log you out after five minutes of inactivity. If you're still using M-Track, select 'Continue' before your session expires";
export const TEXT_SESSION_TIMEOUT_BUTTON = 'Continue';

export const TEXT_SESSION_EXPIRED_HEADER = "Your session's expired";
export const TEXT_SESSION_EXPIRED_BODY = 'For security reasons, your session has automatically expired. Tap the button below to log back in.';
export const TEXT_SESSION_EXPIRED_BODY_NATIVE = 'For security reasons, your session has automatically expired.';
export const TEXT_SESSION_EXPIRED_BUTTON = 'Log back in';

export const TEXT_ERROR_PAGE_HEADER = "Sorry, something isn't right";
export const TEXT_ERROR_PAGE_DEFAULT_DESCRIPTION = "We're having trouble connecting you just now.";
export const TEXT_ERROR_PAGE_BUTTON = 'Try again';

export const TEXT_ERROR_404_PAGE_HEADER = "Sorry, we can't find the page you are looking for";
export const TEXT_ERROR_404_PAGE_BODY = 'Go back to pick up where you left off, or head back to your ';
export const TEXT_ERROR_404_PAGE_BODY_NO_CONSENT = 'Go back to pick up where you left off, or head over to ';
export const TEXT_ERROR_404_PAGE_BODY_INLINE = 'M-Track dashboard.';
export const TEXT_ERROR_404_PAGE_BODY_INLINE_NO_CONSENT = 'Marketplace.';
